import { createAction } from 'redux-act';
// add FinancialYear action
const addFinancialYearRequest = createAction('ADD_FINANCIAL_YEAR_REQUEST', data => data);
const addFinancialYearSuccess = createAction('ADD_FINANCIAL_YEAR_SUCCESS', data => data);
const addFinancialYearError = createAction('ADD_FINANCIAL_YEAR_ERROR');

// Update FinancialYear action
const updateFinancialYearRequest = createAction('Update_FINANCIAL_YEAR_REQUEST', data => data);
const updateFinancialYearSuccess = createAction('Update_FINANCIAL_YEAR_SUCCESS', data => data);
const updateFinancialYearError = createAction('Update_FINANCIAL_YEAR_ERROR');

// get FinancialYear action
const getAllFinancialYearRequest = createAction('GET_ALL_FINANCIAL_YEAR_REQUEST', data => data);
const getAllFinancialYearSuccess = createAction('GET_ALL_FINANCIAL_YEAR_SUCCESS', data => data);
const getAllFinancialYearError = createAction('GET_ALL_FINANCIAL_YEAR_ERROR');

// Get FinancialYear List action
const getFinancialYearListRequest = createAction('GET_FINANCIAL_YEAR_LIST_REQUEST', data => data);
const getFinancialYearListSuccess = createAction('GET_FINANCIAL_YEAR_LIST_SUCCESS', data => data);
const getFinancialYearListError = createAction('GET_FINANCIAL_YEAR_LIST_ERROR');


// Get FinancialYear Wise Month action
const getFinancialYearWiseMonthRequest = createAction('GET_FINANCIAL_WISE_MONTH_REQUEST', data => data);
const getFinancialYearWiseMonthSuccess = createAction('GET_FINANCIAL_WISE_MONTH_SUCCESS', data => data);
const getFinancialYearWiseMonthError = createAction('GET_FINANCIAL_WISE_MONTH_ERROR');

// clear existing FinancialYear action
const handleClearFinancialYearStore = createAction('HANDLE_CLEAR_FINANCIAL_YEAR_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addFinancialYearRequest,
    addFinancialYearSuccess,
    addFinancialYearError,

    updateFinancialYearRequest,
    updateFinancialYearSuccess,
    updateFinancialYearError,

    getAllFinancialYearRequest,
    getAllFinancialYearSuccess,
    getAllFinancialYearError,

    getFinancialYearListRequest,
    getFinancialYearListSuccess,
    getFinancialYearListError,

    getFinancialYearWiseMonthRequest,
    getFinancialYearWiseMonthSuccess,
    getFinancialYearWiseMonthError,



    
    handleClearFinancialYearStore,
    // toastMsgAction,
    
}